import { parseVer4TreeResponse } from '#/api/adapters/envelope';
import request from '#/utils/request';

export async function fetchInventoryStockByStockNo(stockNo) {
  const { data: raw } = await request.get('/inv/inventory-stock/by-stock-no', {
    params: { stock_no: stockNo },
  });

  return parseVer4TreeResponse(raw);
}
